// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__8n6ft","social":"style_social__3d91a","ftrLnk":"style_ftrLnk__5c3SW","ftrTitle":"style_ftrTitle__Q8WeP","ftrLnkWrapper":"style_ftrLnkWrapper__BhEp8"};